import { Box } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";

export interface ITkInquiryTableListProps {
  title: string; // タイトル
  lock?: boolean; // 鍵
  keyword: string; // key
  text?: any; // 値
  fill?: boolean; // 網掛け
}
interface ITkInquiryTableProps {
  list: ITkInquiryTableListProps[][];
  tableTitle?: string;
}

const TkInquiryTable: React.FC<ITkInquiryTableProps> = (props) => {
  const { list, tableTitle } = props;

  return (
    <Box className="tkInquiryTable">
      {tableTitle && <Box className="tkLineTitle">{tableTitle}</Box>}

      <Box className="tableMain">
        {list.map((item, index) => (
          <Box
            className={`table ${item.length === 1 ? "single" : ""}`}
            key={index}
          >
            {item.map((d, i) => (
              <Box className="tableLine" key={`${index}-${i}`}>
                <Box className="tableTitle">
                  {d.title}
                  {d.lock && <LockIcon />}
                </Box>

                <Box className={`tableText ${d.fill ? "colored" : ""}`}>
                  {d.text}
                </Box>
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export { TkInquiryTable };
